<res-base-modal [modalTitle]="'Generate Load File'" [modalClass]="modalClass" [modalAutomationId]="automationId"
    [primaryButtonLabel]="'OK'" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [isPrimaryBtnEnabled]="okEnabled()" [secondaryButtonLabel]="'Cancel'" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex" [modalHasVariableHeight]="true">

    <div>
        <div class="export-row">
            <div class="export-row-column-first data-area-field-info">
                <div class="export-row export-row-padded-top export-row-padded-left-right">
                    <label requiredAsterisk>Export Data Area:</label>
                    <select [attr.data-automation-id]="automationId + '-export-data-area'"
                        [(ngModel)]="exportOptions.dataAreaHandle" (blur)="validation.dataAreaHandle.check()"
                        [(resScrollablePopover)]="validation.dataAreaHandle.invalid"
                        [popoverErrorMessage]="validation.dataAreaHandle.errorMessage" popoverType="error"
                        popoverPlacement="bottom"
                        [popoverAutomationId]="automationId + '-export-data-area-error-message'">
                        <option *ngFor="let dataArea of extraOptions.exportDataAreas" [ngValue]="dataArea.handle">
                            {{dataArea.name}}</option>
                    </select>
                </div>
                <div class="export-row export-row-padded">
                    <label>Export Fields:</label>
                    <select [attr.data-automation-id]="automationId + '-export-fields'"
                        [(ngModel)]="exportOptions.metadataTemplateHandle">
                        <optgroup label="Project Templates:">
                            <option *ngFor="let template of extraOptions.exportFieldTemplates.project"
                                [ngValue]="template.handle">{{template.name}}</option>
                        </optgroup>
                        <optgroup label="Organization Templates:">
                            <option *ngFor="let template of extraOptions.exportFieldTemplates.organization"
                                [ngValue]="template.handle">{{template.name}}</option>
                        </optgroup>
                        <optgroup label="System Templates:" *ngIf="isSystemUserWithPermissions">
                            <option *ngFor="let template of extraOptions.exportFieldTemplates.system"
                                [ngValue]="template.handle">{{template.name}}</option>
                        </optgroup>
                    </select>
                </div>
            </div>
            <div class="export-row-column-second bordered-left analytic-processing">
                <div class="export-header">Analytic Processing</div>
                <div class="export-row export-row-padded">
                    <res-custom-checkbox [automationId]="automationId + '-threadgroup-includes-attachments'"
                        [(ngModel)]="exportOptions.includeThreadAttach" content="ThreadGroup includes Attachments"
                        [isDisabled]="disabled.includeThreadAttach()"></res-custom-checkbox>
                </div>
            </div>
        </div>
        <res-export-output-formatting-options [automationId]="automationId" [exportOptions]="exportOptions"
            [isExportVolume]="isExportVolume" [extraOptions]="extraOptions" [onChange]="onChange" [disabled]="disabled"
            [validation]="validation" [generateLoadFile]="true" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
        </res-export-output-formatting-options>
        <div class="export-header">Production Settings</div>
        <div class="export-row export-row-padded-top export-row-padded-left-right production-settings">
            <label>Base Path:</label>
            <input type="text" [(ngModel)]="exportOptions.basePath"
                [attr.data-automation-id]="automationId + '-production-base-path-input'">
        </div>
        <div class="export-row export-row-padded">
            <res-custom-checkbox [automationId]="automationId + '-include-volume-label'"
                content="Include Volume Label and # in Path Fields" [(ngModel)]="exportOptions.includeVolumeLabelInPath"
                [isDisabled]="disabled.noOfOutputFormats() == 6 || extraOptions.consolidatedManifest">
            </res-custom-checkbox>
        </div>
        <div class="export-header">Filter by Last Update</div>
        <div class="export-row export-row-padded-top export-row-padded-left-right">
            <label>Only include documents affected by the following updates to this export stream:</label>
        </div>
        <div class="export-row export-row-padded-left-right export-row-padded-bottom export-row-vertical update-dates">
            <res-custom-checkbox *ngFor="let updateDate of extraOptions.updateDates; index as i; trackBy:identify"
                [automationId]="automationId + '-update-date-' + updateDate.displayName"
                [(ngModel)]="updateDate.selected" [content]="updateDate.displayName"></res-custom-checkbox>
        </div>
    </div>
</res-base-modal>